export default {
    maintenance: 'Сайт знаходиться на технічному обслуговуванні. Ми повернемося за кілька хвилин!',

    //General phrases
    tollWord: 'Плата за міст Фетешти | Податки на міст Фетешти | дорожній збір ',
    vignetteWord: 'Ровіньєте | Ровіньєте',

    site_tpf: 'taxa-pod-fetesti.ro',
    site_erv: 'e-rovinieta.ro',

    currency: 'лей',
    category: 'категорія',
    select_type_of_vehicle: 'Виберіть тип транспортного засобу',
    select_the_period: 'Виберіть період',
    or_pay_for: 'Або заплатити за',
    your_vehicles_link: 'ваші автомобілі',
    or_go_to_your_account_and_buy: 'Увійдіть і купуйте для своїх автомобілів',
    see_cart: 'Дивіться кошик',
    or: 'або',
    and: 'i',
    back: 'назад',
    total: 'Всього',
    pf: 'Фізична особа',
    pj: 'Юридична особа ',
    yes: 'Так',
    no: 'ні',
    about: 'Про',
    us: 'ми',

    vignette: 'Ровіньєте | Ровіньєте',
    passing: 'прохід | переходи',

    toll_buy: 'Сплатити збір за міст',
    vignette_buy: 'Платіть ровинієту',

    //Order
    billing_add_new_profile: 'Додати новий платіжний профіль',

    cart_empty: 'Кошик порожній',
    cart_available_from: 'діє з',
    cart_add_more: 'Продовжуйте додавати більше до свого кошика',
    cart_continue_with_buying: 'Купити більше',
    cart_validation_errors: 'Продукти вилучені з замовлення через помилки перевірки',

    order_container_place_order_title: 'Розмістіть замовлення',
    order_container_my_cart: 'Мій кошик',
    order_container_billing_info: 'виставлення рахунків',
    order_container_payment: 'Платіж',

    payment_method_insuficient_credit: 'недостатній кредит',
    payment_method_instant_credit: 'Миттєвий кредит',
    payment_method_instant_credit_description: 'Миттєвий кредит ',
    payment_method_credit_card: 'Онлайн за допомогою банківської карти',
    payment_method_credit_card_description: 'Оплата буде оброблятися через PayU.ro',
    payment_method_iTransfer_description: 'Платіжне доручення з негайним підтвердженням',
    payment_method_payment_order: 'Платіжне доручення',
    payment_method_payment_order_description: 'Ви отримаєте електронною поштою проформу, пов’язану з покупкою, що містить інструкції щодо оплати. Замовлення буде видано після отримання оплати',
    payment_method_credit_erv: 'Кредит e-rovinietă',
    payment_method_credit_tpf: 'Податковий кредит через міст Фетешт',
    payment_method_terms: 'Я підтверджую, що наведені вище дані правильні, я прочитав і погоджуюся з ними',
    payment_method_op_not_available_during_weekend: 'Неможливо оплатити OP з четверга 16:30 до неділі 23:59.',
    payment_method_op_not_available_last_day_of_month: 'Оплатити ОП в останній день місяця неможливо',

    thank_you_placed_order_title: 'Вітаю',
    thank_you_successful_order: 'Замовлення успішно розміщено. Подивіться її статус у своїх замовленнях.',
    thank_you_successful_order_not_loggedin: 'Замовлення успішно розміщено. Рахунок-фактура з виданою ровіньетою буде надіслано вам на електронну пошту.',
    thank_you_see_info_order: 'Не виходьте, поки не отримаєте ровінієту електронною поштою або її дані по SMS.',
    thank_you_see_info_order_not_loggedin: 'Не вирушайте в дорогу, перш ніж перевірити, чи отримали ви ровінєту.',
    thank_you_my_orders: 'Detalii comandă',
    thank_you_extra_info_not_loggedin: 'Створіть обліковий запис і збережіть дані для майбутніх замовлень',

    thank_you_itransfer_or_debit_card_or_instant_credit: 'Дякуємо за оплату. Ви отримаєте підтвердження видачі вашого замовлення на електронну пошту якомога швидше. Будь ласка, не виходьте, поки не отримаєте підтвердження видачі замовлення.',
    thank_you_op_payment: 'якуємо за замовлення. Ми надіслали вам проформу-рахунок електронною поштою, будь ласка, оплатіть його на рахунки, зазначені в документі, та надішліть нам замовлення на адресу contact@e-rovinieta.ro',

    //Account
    continue_with: 'Продовжуйте',
    continue: 'Продовжувати їхати',
    account_activate_header: 'Активувати обліковий запис',
    account_activate_message: '',

    account_container_my_account: 'Мій рахунок',
    account_container_vehicles: 'транспортні засоби',
    account_container_orders: 'Замовлення',
    account_container_profiles: 'Платіжні профілі',
    account_container_info: 'Дані облікового запису',
    account_container_cards: 'КАРТКИ',

    account_data_title: 'Дані облікового запису',

    add_car_title: 'Додайте машину',

    edit_car_no_vehicles: 'Транспортних засобів не знайдено!',
    edit_car_delete_vehicle_title: 'Протріть автомобіль',
    edit_car_delete_vehicle: 'Ви впевнені, що хочете видалити цей автомобіль?',

    delete_product_title: 'Видалити товар',
    delete_product: 'Ви впевнені, що хочете видалити цей продукт?',

    add_profile_title: 'Додати профіль',
    add_profile_pj_extracted: 'Автоматично витягуються дані про юридичну особу',

    edit_profile_title: 'змінити профіль',
    edit_profile_delete_profile_title: 'Видалити профіль',
    edit_profile_delete_profile: 'Ви впевнені, що хочете видалити цей профіль?',

    my_orders_passings: 'пропуск  | {count} переходи',

    profiles_main: 'Головний',
    profiles_secondary: 'Вторинний',
    profiles_unverified_data: 'Неперевірені дані',
    profiles_no_profile: 'Немає профілю',
    profiles_delete_profile: 'Видалити профіль',
    profiles_are_you_sure: 'Ви впевнені, що хочете видалити профіль?',

    search_car_button: 'Шукати ',
    search_car_after_license_plate: 'Пошук за номером',

    //Authentication
    login_auth: 'Увійти',
    login_login_into_your_account: 'Увійдіть у свій обліковий запис',

    login_component_login_by: 'Увійти за допомогою',
    login_component_no_account: 'Немає облікового запису?',
    login_component_forgot_password: 'Ви забули пароль?',

    new_account_title: 'зареєструватися',
    new_account_details: 'Дані облікового запису',
    new_account_ive_read: 'Прочитав і погоджуюсь',
    new_account_tc: 'Правила та умови',
    new_account_site: 'веб-сайт',
    mandatory: 'обов\'язковий',
    new_account_pc: 'політика конфіденційності',
    new_account_must_accept_tc: 'Ви повинні погодитися з умовами та політикою конфіденційності',
    new_account_must_accept_pc: 'Ви повинні прийняти політику конфіденційності',

    contact_title: 'Контакти',

    faq_title: 'Часті запитання',

    header_how_does_it_work: 'Як це працює?',

    how_it_works_p1: 'Ви вже в дорозі через 3 хвилини!',
    how_it_works_p2: 'Авторизований дилер CNAIR',
    how_it_works_p3: 'Замовляйте онлайн на taxa-pod-fetesti.ro',

    toll_category_error_loading_car: 'Проблема із завантаженням автомобіля',
    toll_category_error_loading_country: 'Проблема із завантаженням країн',

    vignette_category_error_fromdate: 'Виберіть дату, коли ровінєта набуде чинності',
    vignette_category_chasis_warning_msg: 'Серія шасі на 1 день не є обов’язковою',
    vignette_category_chasis_warning_msg_7: 'Для 7-денних ровинєт серія шасі не є обов’язковою',

    reset_password_title: 'Скинути пароль',
    reset_password_label: 'Введіть електронну адресу',

    reset_password_update_title: 'Збережіть новий пароль',

    //Buttons
    btn_save: 'Зберегти ',
    btn_save_changes: 'Зберегти зміни',
    btn_add_car: 'Додати транспортний засіб',
    btn_delete_car: 'Протріть автомобіль',
    btn_next_step: 'Наступний крок',
    btn_finish: 'Завершіть замовлення',
    btn_grab_data_company: 'Візьміть дати<br/> Торговий реєстр',
    btn_add_profile: 'Додати новий профіль',
    btn_i_understand: 'Я розумію',
    btn_login: 'Увійти',
    btn_register: 'зареєструватися',
    btn_create_account: 'Створити обліковий запис',
    btn_add_to_cart: 'Додати в кошик',
    btn_edit_to_cart: 'Змінити продукт',
    btn_reset_password: 'Скинути пароль',
    btn_bill: 'звинувачення',
    btn_choose_payment_method: 'Виберіть спосіб оплати',
    btn_send: 'відправити повідомлення',


    //Labels
    label_category: 'Категорія',
    label_choose_category_contact: 'Виберіть категорію',
    label_message: 'повідомлення',
    label_email: 'Електронна пошта',
    label_password: 'Пароль',
    label_confirm_password: 'Підтвердити пароль',
    label_phone: 'Телефон',
    label_license_plate: 'Реєстраційний номер',
    label_chasis_number: 'Серія шасі',
    label_registration_country: 'Країна реєстрації',
    label_motif: 'Причина нижчої категорії',
    label_choose_category: 'Виберіть категорію для',
    label_billing_type: 'Виставлення рахунків увімкнено',
    label_last_name: 'Ім\'я',
    label_first_name: 'Ім\'я',
    label_country: 'Країна',
    label_county: 'область',
    label_city: 'Місто',
    label_address: 'Адреса',
    label_cui: 'податковий ідентифікаційний код',
    label_reg_com: 'Торговий реєстр',
    label_locality: 'місцевий',
    label_company_name: 'Назва компанії',
    label_for_car: 'Для автомобіля',
    label_available_from: 'Діє з',
    label_optional_field: 'необов\'язковий',

    //terms
    terms: 'Правила та умови',
    partners: 'партнер',
    distribution: 'пункти розповсюдження',
    legislative_info: 'Законодавча інформація',

    //menu pages
    how_it_works: 'Як це працює',
    info: 'Законодавча інформація',
    for_companies: 'Для компаній',
    distribution_untrr: 'Список точок розповсюдження UNTRR',
    about_us: 'Про нас',
    cookies: 'файли cookie ',

    //footer
    footer_new_account_link: 'Приходьте з професіоналами',

    //New terms
    btn_edit: 'Внести зміни',
    btn_edit_password: 'Змінити пароль',
    btn_edit_phone: 'Змінити телефон',
    btn_delete_account: 'Видалити аккаунт',
    btn_import_csv: 'Імпорт csv',
    btn_export_csv: 'Експортувати csv',

    //account
    data_saved_succesfully: 'Дані успішно збережено',
    invalid_plate_number_message: 'Номер не в правильному форматі',
    invalid: 'Недійсний',
    countries_loading: 'Проблема із завантаженням країн',
    tpf_categories_loading: 'Проблема із завантаженням категорій плати за фетальний міст',
    erv_categories_loading: 'Проблема із завантаженням категорій ровинієта',
    csv_header: '"Номер", "Шасі", "Категорія країни", "Категорія податку в країні", "Країна"',
    order_header_name: 'Ім\'я',
    date: 'Дата',
    order_header_payment_type: 'Тип оплати',
    order_header_status: 'Статус',
    no_placed_order: 'Немає замовлень.',
    i_want: 'я хочу',
    no_order: 'Замовлення знайти не вдалося.',
    delete_request_sent_message: 'Запит на видалення облікового запису надіслано',
    delete_request_already_sent_message: 'Запит уже надіслано',

    product_status: 'Статус',
    product_payment_method: 'Спосіб оплати',
    product_bill_data: 'Платіжні дані',
    product_valability: 'Термін дії',

    download_bill: 'Завантажте рахунок-фактуру',
    vignette_series: 'Серія Ровінієта.',
    toll_series: 'Платна серія',

    //authentication
    login_account: 'Увійти',
    already_have_account: 'Вже є аккаунт?',
    password: 'Пароль',
    password_confirm: 'Повторіть пароль',
    return_to_login_1: 'Повернутися до',
    return_to_login_2: 'Увійти',

    // order
    order_title: 'Деталі вашого замовлення з ідентифікатором #',
    choose_profile: 'Виберіть профіль',
    order_step4: 'Крок 4. Оплата',
    login_to_your_account: 'Увійдіть у свій обліковий запис',
    login_to_your_account_2: 'і виберіть вже збережені платіжні дані.',
    order_without_account: 'Ви можете оформити замовлення без облікового запису, заповнивши дані нижче',
    fill_all_fields: 'Заповніть усі обов’язкові поля',
    order_address_info: 'За цією адресою ви отримаєте рахунок-фактуру та ровінієту',
    invalid_profile_msg: 'Цей профіль недійсний',
    delete_profile_msg: 'Видалити профіль',
    delete_profile_confirm: 'Ви впевнені, що хочете видалити профіль?',
    invalid_email: 'Недійсна електронна адреса',
    invalid_tel: 'Недійсний телефон',
    mandatory_city: 'Місто є обов’язковим',
    mandatory_first_name: 'Укажіть ім’я ',
    mandatory_last_name: 'Укажіть ім’я ',
    mandatory_country: 'Округ є обов\'язковим',
    mandatory_fiscal_code: 'Потрібен ІПН',
    mandatory_j_code: 'Торговий реєстр є обов’язковим',
    mandatory_company: 'Компанія обов\'язкова',
    mandatory_address: 'Необхідна адреса',
    my_shopping_cart: 'Мій кошик',
    order_step3: 'Крок 3: Підсумок',
    buy_vignette_or_bridge_fee: 'Ви можете купити Ровіньєта або податок через міст Фетешти',
    order_step5: 'Крок 5: Оплата',
    warning: 'УВАЖНО!',
    warning_txt_1: 'Для оплати ровинєти ​​платіжним дорученням замовлення буде затверджено після інкасації грошей на банківський рахунок УНТРР.',
    warning_txt_2: 'Ровинець, оплачений платіжним дорученням, видається з понеділка по п’ятницю з 08:00 до 16:30.',
    warning_txt_3: 'Не виїжджайте в дорогу, поки не отримаєте підтвердження про видачу ровінєти.',
    warning_txt_4: 'UNTRR не несе відповідальності за недотримання вищезазначених умов!',
    choose_card: 'Виберіть одну зі збережених карток',
    new_card: 'Нова картка',
    add_card_for_next_transactions: 'Додати картку до мого облікового запису для майбутніх покупок',

    free: 'Безкоштовний',
    btn_logout: 'Вийти',

    frequent_questions_heading: 'Часті запитання та відповіді',
    see_all_frequent_questions: 'Перегляньте всі запитання та відповіді',

    step: 'Крок  {n}',
    choose_passings_number: 'Виберіть кількість пропусків',

    juridical_person: 'Юридична особа',
    individual_person: 'Фізична особа',
    auto_query_company_data: 'Ми автоматично отримуємо дані вашої компанії',
    verified_company_data: 'Дані компанії перевірені!',
    unverified_company_data: 'Неперевірені дані компанії',
    unverified_company_data_with_manual_completion: 'Автоматична перевірка недоступна, заповніть поля вручну',
    check_vignette_valability: 'Перевірте дійсність',
    resources: 'Ресурси ',
    i_want_vignette: 'Я хочу ровінєту',
    i_want_toll: 'Я хочу податок за міст Фетешти',
    vehicle_type: 'Тип транспортного засобу',
    period: 'Період',
    summary: 'Резюме',
    billing: 'виставлення рахунків',
    payment: 'Платіж',
    you_have_multiple_usernames: 'Ти маєш <b>{count}</b> облікові записи, пов’язані з цією електронною поштою. ',
    choose_login_account: 'Виберіть обліковий запис, за допомогою якого ви хочете ввійти',

    //benefits page
    bp_heading: 'Крім того',
    bp_company_advantages: 'Переваги для компаній',
    bp_one_account_multiple_advantages: 'Один обліковий запис, кілька переваг',
    bp_contact_us_for_personalized_solution: 'Зв’яжіться з нами, щоб отримати індивідуальне рішення',
    bp_online_emission: 'Трансляція онлайн 24/7',
    bp_online_assistance: 'У вас є онлайн-підтримка, і ви можете цілодобово  без вихідних придбати ровинєту або податок через міст Фетешти',
    bp_import_your_cars: 'Імпортувати весь флот',
    bp_import_you_cars_through_excel: 'импортуйте від нас весь автопарк компанії на основі файлу excel.',
    bp_multiple_profiles: 'Більше профілів',
    bp_multiple_profiles_for_same_email: 'Ви можете створити кілька профілів для всіх бізнес-користувачів з однією адресою електронної пошти.',
    bp_vignettes_status: 'Ровинієтський статус',
    bp_verify_vignette_status: 'На сайті ви завжди можете перевірити стан виданих ровинців.',
    bp_orders_history: 'Історія Замовлень',
    bp_orders_history_description: 'В обліковому записі ви можете знайти всі розміщені замовлення та рахунки.',
    bp_multiple_orders: 'Кілька команд',
    bp_multiple_orders_description: 'Ви можете додати кілька вереток у кошик і зробити кілька замовлень. ',
    bp_email_sms_confirmation: 'Підтвердження електронною поштою та SMS',
    bp_email_sms_confirmation_description: 'Отримайте підтвердження про видачу ровінєти електронною поштою та SMS. ',
    bp_expiry_alerts: 'Сповіщення про закінчення терміну дії',
    bp_expiry_alerts_description: 'Якщо термін придатності 30 днів більше, ми повідомимо вас електронною поштою до закінчення терміну його дії.',
    bp_need_help: 'Потрібна допомога?',
    bp_call_operators: 'Зателефонуйте до одного з наших операторів, щоб отримати допомогу у видачі ровинців. Послуга доступна з понеділка по п’ятницю (крім святкових днів) з 08:00 до 17:00. ',
    bp_offices: 'Список представництв ',
    bp_have_cars: 'Чи є у вас автопарк?',
    bp_contact_us_for_personalized_solution_for_your_bussiness: 'Зв’яжіться з нами, щоб надати індивідуальне рішення для вашого бізнесу.',
    bp_contact_us_now: 'Зв\'яжіться з нами зараз',


    //contact
    contact_viggnete_emission: 'Видача ровинієта',
    contact_agencies: 'Агентство',
    contact_see_all_agencies: 'Перегляньте всі регіональні агентства',
    contact_see_all_agencies_continuation: 'де можна взяти ровиніете.',
    message_sent_successfully: 'Повідомлення успішно надіслано! Ми зв\'яжемося з вами за вказаною електронною поштою якомога швидше!',
    message_sent_error: 'У мене виникла проблема з надсиланням повідомлення. Будь ласка, поверніться пізніше!',
    category_1: 'Рівнієта дійсність',
    category_2: 'Замовлення',
    category_3: 'Оплата Ровінета',
    category_4: 'Пропозиції компанії',
    category_5: 'Інша інформація',

    //distribution
    distribution_header: 'ПЕРЕЛІК РОБОЧИХ ПУНКТІВ, ЩО НАЛЕЖАЮТЬСЯ ОРГАНУ ЗБІРАННЯ ТАРИФУ НА ВИКОРИСТАННЯ НАЦІОНАЛЬНОЇ ДОРОЖНЬОЇ МЕРЕЖІ В РУМУНІЇ (РОВІНЄТА)',
    distribution_nr_crt: '№ Ні.',
    distribution_work_point: 'Робоча станція',
    distribution_terminals_and_portals: 'ВЕБ-ТЕРМІНАЛИ ТА ПОРТАЛИ',
    distribution_name: 'Ім\'я',
    distribution_terminals: 'Термінал ZEBRAPAY',
    distribution_location_terminal_details: 'нформація про місцезнаходження терміналу ZEBRAPAY',
    distribution_untrr_portal: 'ПОРТАЛ UNTRR',


    //footer
    footer_copyright: 'Всі права захищено 2010  - {currentYear} @ Uniunea Naţională a Transportatorilor Rutieri din România.',


    //homepage
    homepage_authorized_distributor: 'Авторизований дистриб\'ютор C.N.A.I.R ',
    homepage_buy_tpf_erv: 'Придбайте Ровіньєта або податок через міст Фетешти',
    homepage_ready_for_road: 'Готовий негайно їхати',
    homepage_order: 'Команда',
    homepage_payment: 'Перевіряти',
    homepage_drive: 'подорожі',
    homepage_your_advantages: 'Ваші переваги',
    homepage_vignette_availability: 'Перевірте ровіньєту',
    homepage_vignette_availability_description_1: 'Не знаєте, чи є у вас дійсна ровінєта? Уникайте штрафу.',
    homepage_vignette_availability_description_2: 'Перевірте дійсність тут',
    homepage_save_data: 'Збережіть дані',
    homepage_save_data_description: 'Ви створюєте обліковий запис, зберігаєте дані автомобіля та купуєте ровинєту та податок на міст Фетешти в одному місці.',
    homepage_sms_email_delivery: 'Доставка електронною поштою та SMS',
    homepage_sms_email_delivery_description: 'Доставка електронною поштою та SMS ',
    homepage_card_or_op: 'Оплата карткою або ОП',
    homepage_card_or_op_description: 'Швидка та безпечна покупка банківською карткою або платіжним дорученням.',
    homepage_notify_expiry: 'Повідомлення про закінчення терміну дії',
    homepage_notify_expiry_description: 'Для rovinieta на термін більше 30 днів ми попереджаємо вас до закінчення терміну його дії.',
    homepage_professional_services: 'Професійні послуги',
    homepage_professional_services_description: 'Від професіоналів транспорту для всіх користувачів дорожньої мережі в Румунії.',
    homepage_online_assistance: 'Крім того, у вас є онлайн-підтримка та індивідуальне рішення для потреб вашого бізнесу.',
    homepage_discover_all_benefits: 'Відкрийте для себе всі переваги',
    homepage_distribution_points: 'Пункти розподілу',
    homepage_authorized_distributor_2: 'UNTRR є авторизованим дистриб\'ютором C.N.A.I.R. для випуску електронних бюлетенів з онлайн-присутністю та територіальними пунктами.',
    homepage_distribution_points_description: 'Дивіться список точок розповсюдження',
    homepage_frequent_questions: 'Часті запитання та відповіді',
    homepage_frequent_questions_description: 'Перегляньте всі запитання та відповіді',

    //info
    info_download_file: 'Завантажити файл',

    //reset
    reset_cart: 'Кошик скинуто.',

    buy_vignette: 'Купити ровинєту ',
    buy_toll: 'Купити плату за міст Фетешти',

    no_saved_credit_card: 'У вас немає збережених карток!',
    card_delete_title: 'Видалити картку',
    card_delete_body: 'Ви впевнені, що хочете видалити картку?',


    //verify vignette
    verify_vignette_title: 'Перевірте ровинєту',
    heel_series: 'Серія каблуків',
    heel_number: 'Номер каблука',
    request_verify_vignette: 'Запит на перевірку в CNAIR',
    btn_verify: 'Перевірка',
    vignette_available_until: 'Rovinieta діє до  ',
    error: 'З запитом сталася помилка, поверніться пізніше. ',
    you_will_be_contacted: 'Оператори UNTRR перевірять статус вашої ровінети та повернуться з відповіддю між 08:00 та 17:00.',


    //cars
    show_all_vehicles: 'Відображає всі транспортні засоби',
    show_only_active_vignette_vehicles: 'Ровініете активний',
    show_only_expired_vignette_vehicles: 'Виснажені руїни',

    sort_by_car_name: 'Реєстраційний номер за алфавітом',
    sort_vignette_expiry: 'Термін придатності ровіньєта',

    //peaj
    vehicles: 'Автомобілі',

    //vehicles
    active: 'Активний до',
    expired: 'Термін дії закінчився',
    unknown: 'Невідомо',
    vignette_status: 'недійсна ровініета',
    btn_show_more_info: 'Приховати інформацію про імпорт',
    btn_show_less_info: 'Приховати інформацію про імпорт',
    imported_vehicles: 'Це було імпортовано  {vehicles} транспортний засіб  | Вони були імпортні {vehicles} транспортний засіб',

    //orders
    choose_status: 'Виберіть статус',
    continue_payment: 'Продовжувати оплату ',

    overlapping_products: 'Цей продукт перекриває інший товар у кошику',
    aleady_active_vignette: 'Вже йде активна ровінєта до {date} для цього автомобіля.',

    Zi_1: '1 днів ',
    Zi_7: '7 днів ',
    Zi_10: '10 днів ',
    Zi_60: '60 днів ',
    Zi_30: '30 днів ',
    Zi_90: '90 днів ',
    Luna_12: '12 місяців',
    days: 'один день | {count} днів',
    months: 'один місяць | {count} місяців ',

    see_all_your_vehicles: 'Перегляньте всі свої транспортні засоби',
    here: 'тут',

    fill_in_tpf_category: 'Заповніть кат. TPF',
    fill_in_erv_category: 'Заповніть кат. ровінєта ',
    
    chasis_number_warning: 'Серія шасі є обов’язковою для {label} віньєтка',
    please_check_informations: 'Будь ласка, перевірте правильний реєстраційний номер, перш ніж перейти до способу оплати. Дякую!',

    sort_by: 'Сортувати за',
    type: 'Тип',

    sms_notice: '<strong>Платна послуга повідомлень через СМС</strong><br/><br/> Послуга коротких повідомлень (СМС) дозволяє повідомляти клієнтів www.taxa-pod-fetesti.ro для підтвердження видачі плата за міст, відповідно, повідомляти клієнтів про завершення терміну дії плата за міст. Послуга не є обов&#39;язковою, надається на вибір клієнта і дійсна тільки для замовлень, оплачених онлайн через платіжну систему (PayU).<br/><br/> За відповідність даних та інформації з СМС про видачу та/або завершення терміну дії плата за міст, реєстраційного номера, серії шасі та номера мобільного телефону, введених на платформі www.taxa-pod-fetesti.ro , відповідальність несе користувач. СМС-повідомлення здійснюється через NETOPIA Payments.<br/><br/> Система SMS-повідомлень надсилає повідомлення клієнтам, які обрали цю послугу. На отримання СМС з підтвердженням/завершенням терміну дії може впливати робота та покриття телекомунікаційних мереж, робота пристроїв, що використовуються тощо.<br/><br/> Для повідомлень, будь ласка, скористайтеся контактною сторінкою веб-сайту www.taxa-pod-fetesti.ro.<br/><br/>'
};